export default __webpack_public_path__ + "img/feature_enter_code.68945a01.svg";